<template>
  <div
    class="IndexMarquee"
    @mouseenter="onMouseenter"
    @mouseleave="onMouseleave"
  >
    <div class="item" ref="marquee1">
      <div
        v-for="(item, index) in list"
        :key="`img1${index}`"
        :style="{ width: `${item.width / 16}rem` }"
        class="img-box"
      >
        <img :src="item.url" />
        <div v-if="item.name" class="name">{{ item.name }}</div>
      </div>
    </div>
    <div class="item" ref="marquee2">
      <div
        v-for="(item, index) in list"
        :key="`img2${index}`"
        :style="{ width: `${item.width / 16}rem` }"
        class="img-box"
      >
        <img :src="item.url" />
        <div v-if="item.name" class="name">{{ item.name }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "IndexMarquee",
  props: {
    list: {
      type: Array,
      default() {
        return [];
      },
    },
    initX: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      marqueeRaf: null,
      translateX: 0,
    };
  },
  mounted() {
    this.translateX = this.initX;
    this.$refs.marquee1.style.transform = `translateX(${this.translateX}px)`;
    this.$refs.marquee2.style.transform = `translateX(${this.translateX}px)`;
    this.marqueeRaf = requestAnimationFrame(this.marqueeAnimation);
  },
  methods: {
    marqueeAnimation() {
      if (!this.$refs.marquee1) return;
      this.translateX = this.translateX - 1;
      this.$refs.marquee1.style.transform = `translateX(${this.translateX}px)`;
      this.$refs.marquee2.style.transform = `translateX(${this.translateX}px)`;
      this.marqueeRaf = requestAnimationFrame(this.marqueeAnimation);
      if (this.translateX <= this.$refs.marquee1.offsetWidth * -1) {
        this.translateX = 0;
      }
    },
    onMouseenter() {
      if (!this.marqueeRaf) return;
      cancelAnimationFrame(this.marqueeRaf);
      this.marqueeRaf = null;
    },
    onMouseleave() {
      if (this.marqueeRaf) return;
      this.marqueeRaf = requestAnimationFrame(this.marqueeAnimation);
    },
  },
};
</script>

<style lang="less" scoped>
.IndexMarquee {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;

  .item {
    display: flex;
    align-items: center;
    justify-content: center;

    .img-box {
      margin-right: 24px;

      img {
        width: 100%;
        margin-bottom: 16px;
      }

      .name {
        text-align: center;
        font-size: 24px;
      }
    }
  }
}
</style>